// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cost-reports-container {
  padding: 20px;
}

.cost-reports-container .admin-header {
  margin-bottom: 10px;
  font-size: 24px;
  font-weight: 600;
  color: #262626;
}

.cost-reports-container .filter-bar {
  margin-bottom: 20px;
  background-color: white;
  border-radius: 20px;
  padding: 15px;
  -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
          box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

.cost-reports-container .summary-cards {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.cost-reports-container .summary-card {
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  min-width: 200px;
  background: white;
  border-radius: 8px;
  padding: 16px;
  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.cost-reports-container .summary-card .summary-label {
  font-size: 13px;
  color: #8c8c8c;
  margin-bottom: 10px;
}

.cost-reports-container .summary-card .summary-value {
  font-size: 28px;
  font-weight: 600;
  color: #262626;
}

.cost-reports-container .summary-card.warning .summary-value {
  color: #faad14;
}

.cost-reports-container .admin-table-container {
  background: white;
  border-radius: 8px;
  padding: 16px;
}

.cost-reports-container .admin-table-container .ant-table-cell {
  padding: 0.75rem !important;
  font-size: 14px !important;
  line-height: 1.5 !important;
}

.cost-reports-container .table-toolbar {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  margin-bottom: 16px;
}

.cost-reports-container .unpriced-row {
  background-color: #fffbe6;
}

.cost-reports-container .unpriced-row:hover > td {
  background-color: #fff7cc !important;
}

.cost-reports-container .summary-footer-row td {
  background-color: #fafafa !important;
  border-top: 2px solid #f0f0f0;
}

.cost-reports-container .error-message {
  padding: 20px;
  text-align: center;
  background: #fff2f0;
  border: 1px solid #ffccc7;
  border-radius: 4px;
  margin-bottom: 20px;
}

.cost-reports-container .error-message p {
  color: #ff4d4f;
  margin-bottom: 10px;
}
`, "",{"version":3,"sources":["webpack://./pages/CostReports/cost-reports.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,iDAAyC;UAAzC,yCAAyC;AAC3C;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAe;MAAf,eAAe;AACjB;;AAEA;EACE,mBAAO;MAAP,WAAO;UAAP,OAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,iDAAyC;UAAzC,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB","sourcesContent":[".cost-reports-container {\r\n  padding: 20px;\r\n}\r\n\r\n.cost-reports-container .admin-header {\r\n  margin-bottom: 10px;\r\n  font-size: 24px;\r\n  font-weight: 600;\r\n  color: #262626;\r\n}\r\n\r\n.cost-reports-container .filter-bar {\r\n  margin-bottom: 20px;\r\n  background-color: white;\r\n  border-radius: 20px;\r\n  padding: 15px;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);\r\n}\r\n\r\n.cost-reports-container .summary-cards {\r\n  display: flex;\r\n  gap: 16px;\r\n  margin-bottom: 20px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.cost-reports-container .summary-card {\r\n  flex: 1;\r\n  min-width: 200px;\r\n  background: white;\r\n  border-radius: 8px;\r\n  padding: 16px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.cost-reports-container .summary-card .summary-label {\r\n  font-size: 13px;\r\n  color: #8c8c8c;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.cost-reports-container .summary-card .summary-value {\r\n  font-size: 28px;\r\n  font-weight: 600;\r\n  color: #262626;\r\n}\r\n\r\n.cost-reports-container .summary-card.warning .summary-value {\r\n  color: #faad14;\r\n}\r\n\r\n.cost-reports-container .admin-table-container {\r\n  background: white;\r\n  border-radius: 8px;\r\n  padding: 16px;\r\n}\r\n\r\n.cost-reports-container .admin-table-container .ant-table-cell {\r\n  padding: 0.75rem !important;\r\n  font-size: 14px !important;\r\n  line-height: 1.5 !important;\r\n}\r\n\r\n.cost-reports-container .table-toolbar {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.cost-reports-container .unpriced-row {\r\n  background-color: #fffbe6;\r\n}\r\n\r\n.cost-reports-container .unpriced-row:hover > td {\r\n  background-color: #fff7cc !important;\r\n}\r\n\r\n.cost-reports-container .summary-footer-row td {\r\n  background-color: #fafafa !important;\r\n  border-top: 2px solid #f0f0f0;\r\n}\r\n\r\n.cost-reports-container .error-message {\r\n  padding: 20px;\r\n  text-align: center;\r\n  background: #fff2f0;\r\n  border: 1px solid #ffccc7;\r\n  border-radius: 4px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.cost-reports-container .error-message p {\r\n  color: #ff4d4f;\r\n  margin-bottom: 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
